<template>
  <div v-click-outside="close" class="dropdown">
    <div class="bordered-input">
      <div class="dropdown__input" @click="toggleDisplay">
        <div class="dropdown__input--text">
          {{ getLabel }}
        </div>
        <div v-if="!isOpen" class="icon caret-down" />
        <div v-if="isOpen" class="icon caret-up" />
      </div>
    </div>
    <Transition name="slide-fade" v-show="isOpen">
      <div v-show="isOpen" class="dropdown__container">
        <Bedrooms ref="bedroomsRef" />
      </div>
    </Transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { _ } from 'vue-underscore';
import Bus from '../../events/bus';
import responsive from '../../mixins/responsive';
import Bedrooms from '../../pages/results/filters/Bedrooms';


export default {
  name: 'BedroomsDropdown',
  components: {
    Bedrooms,
  },
  directives: {
    ClickOutside,
  },
  mixins: [responsive],
  props: {
    searchVillaId: { type: Number, default: 4 },
  },
  data() {
    return {
      labelText: 'Bedrooms',
      isOpen: false,
    };
  },
  computed: {
    getBedroomsCount() {
      return this.$store.getters['results/getBedrooms'];
    },
    getLabel() {
      if (this.getBedroomsCount == 0) {
        this.labelText = 'Bedrooms';
      }
      if (this.getBedroomsCount == 1) {
        this.labelText = `${this.getBedroomsCount} bedroom`;
      }
      if (this.getBedroomsCount > 1) {
        this.labelText = `${this.getBedroomsCount} bedrooms`;
      }

      return this.labelText;
    },
  },
  mounted() {
    Bus.$on('closeSearchVillaTabs', this.closeTab);
  },
  methods: {
    toggleDisplay() {
      this.isOpen = !this.isOpen;
      this.isOpen ? Bus.$emit('closeSearchVillaTabs', this.searchVillaId) : null;
      if (this.isOpen && !this.isDesktop) {
        this.$nextTick(() => {
          const bedroomsElement = this.$refs.bedroomsRef.$el;
          bedroomsElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    },
    closeTab(id) {
      if (id != this.searchVillaId) {
        this.isOpen = false;
      }
    },
    close() {
      if (this.isDesktop) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";

.dropdown {
    position: relative;
    text-align: left;

    &__input {
      width: 100%;
      height: 70px;
      background-color: $limeStone;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      cursor: pointer;

      &--text {
        color: $darkBlack;
      }

      &.focus {
        background-color: $stoneCream;
      }

      .mobile-search-villa__container & {
        background-color: $stoneWhite;

        &.focus {
          background-color: $stoneWhite;
        }
      }
    }

    &__container {
      position: absolute;
      left: -1px;
      z-index: 10;
      min-width: 315px;
      width: 100%;
      padding: 0 24px;
      background: $limeStone;
      border: 1px solid $stoneLight;

      .search-villa--sticky & {
        bottom: 70px;
      }

      .mobile-search-villa__container & {
        margin-top: 8px;
        background: $stoneWhite;
        border: 1px solid $yellowStone;
      }

      @include desktop-ms-down {
        min-width: 325px;
      }

      @include tablet-down {
        padding: 10px;
        left: 0px;
        width: 100%;
        min-width: 290px;
        margin-top: 5px;
      }

      @include mobile-sm-down {
        width: 100%;
        min-width: 290px;
        padding: 10px;
        left: 0px;
      }
    }

  .icon {
    cursor: pointer;

    &.caret-up {
      background-image: url(../../assets/img/src/icons/chevron-up.svg);
      background-size: 13px 13px;
      width: 13px;
      height: 13px;
    }

    &.caret-down {
      background-image: url(../../assets/img/src/icons/chevron-down.svg);
      background-size: 13px 13px;
      width: 13px;
      height: 13px;
    }
  }
}

</style>
